import { useListsStore } from '@shared/model'

import { useLessonEditStore } from './edit/store'
import { useDisciplineStore } from '../store'
import { getDisciplineName } from '../discipline-general-info'

interface LessonEditTitleReturn {
  refTitle: ComputedRef<string>
}

/** "Editing Math lesson #271927", as the legacy modal was titled; every tab of the lesson page carries it. */
export const useLessonEditTitle = (): LessonEditTitleReturn => {
  const store = useLessonEditStore()
  const disciplineStore = useDisciplineStore()
  const listsStore = useListsStore()

  const refTitle = computed<string>(() => {
    const code = disciplineStore.getDiscipline?.code
    const name = code ? getDisciplineName(code, listsStore.getLists?.discipline.code) : ''
    const id = store.getLesson?.id

    return ['Editing', name, 'lesson', id ? `#${id}` : ''].filter(Boolean).join(' ')
  })

  return {
    refTitle,
  }
}
